import { render } from "./GameManagement.vue?vue&type=template&id=055931e7&scoped=true"
import script from "./GameManagement.vue?vue&type=script&lang=js"
export * from "./GameManagement.vue?vue&type=script&lang=js"

import "./GameManagement.vue?vue&type=style&index=0&id=055931e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055931e7"]])

export default __exports__